<div class="content" #content woa-element-width woa-activatable (onActivate)="showQrCode()"
     [woa-css-var]="{
         '--themed-ticket-body-padding': ['--woa-' + cardTheme() + '-themed-ticket-body-padding', '--woa-default-themed-ticket-body-padding'],
         '--themed-ticket-background-color': ['--woa-' + cardTheme() + '-themed-ticket-background-color', '--woa-default-themed-ticket-background-color'],
         '--themed-ticket-max-column-spec': ['--woa-' + cardTheme() + '-themed-ticket-max-column-spec', '--woa-default-themed-ticket-max-column-spec'],
         '--themed-ticket-header-text-color': ['--woa-' + cardTheme() + '-themed-ticket-header-text-color', '--woa-default-themed-ticket-header-text-color'],
         '--themed-ticket-header-background-color': ['--woa-' + cardTheme() + '-themed-ticket-header-background-color', '--woa-default-themed-ticket-header-background-color'],
         '--themed-ticket-header-background-opacity': ['--woa-' + cardTheme() + '-themed-ticket-header-background-opacity', '--woa-default-themed-ticket-header-background-opacity'],
         '--themed-ticket-footer-text-color': ['--woa-' + cardTheme() + '-themed-ticket-footer-text-color', '--woa-default-themed-ticket-footer-text-color'],
         '--themed-ticket-footer-background-color': ['--woa-' + cardTheme() + '-themed-ticket-footer-background-color', '--woa-default-themed-ticket-footer-background-color'],
         '--themed-ticket-footer-background-opacity': ['--woa-' + cardTheme() + '-themed-ticket-footer-background-opacity', '--woa-default-themed-ticket-footer-background-opacity'],
         '--themed-ticket-placeholder-background-color': ['--woa-' + cardTheme() + '-themed-ticket-placeholder-background-color', '--woa-default-themed-ticket-placeholder-background-color'],
         '--themed-ticket-placeholder-border-color': ['--woa-' + cardTheme() + '-themed-ticket-placeholder-border-color', '--woa-default-themed-ticket-placeholder-border-color'],
         '--themed-ticket-placeholder-opacity': ['--woa-' + cardTheme() + '-themed-ticket-placeholder-opacity', '--woa-default-themed-ticket-placeholder-opacity'],
         '--themed-ticket-stamp-color': ['--woa-' + cardTheme() + '-themed-ticket-stamp-color', '--woa-default-themed-ticket-stamp-color'],
         '--themed-ticket-stamp-opacity': ['--woa-' + cardTheme() + '-themed-ticket-stamp-opacity', '--woa-default-themed-ticket-stamp-opacity'],
         '--themed-ticket-stamp-icon': ['--woa-' + cardTheme() + '-themed-ticket-stamp-icon', '--woa-default-themed-ticket-stamp-icon'],
         '--themed-ticket-stamp-icon-scale': ['--woa-' + cardTheme() + '-themed-ticket-stamp-icon-scale', '--woa-default-themed-ticket-stamp-icon-scale'],
         '--themed-ticket-stamp-icon-rotate-factor': ['--woa-' + cardTheme() + '-themed-ticket-stamp-icon-rotate-factor', '--woa-default-themed-ticket-stamp-icon-rotate-factor']
     }">
    <div class="content-media">
        @if (ticket().image.id) {
            <img class="content-media-object" alt="" [woa-image-cache]="ticket().image">
        }
    </div>
    <div class="content-details" [ngClass]="{'no-image': ticket().image.id == undefined}">
        @if (ticket().title) {
            <div class="content-details-header" id="ticket-name-{{index()}}"
                 woa-responsive [fontScale]=".06">
                {{ ticket().title }}
            </div>
        }
        <div class="content-details-body">
            @if (stampRows() > 0) {
                <div class="content-details-body-stamps" #countdown
                     [woa-css-var]="{
                         '--rows': stampRows(),
                         '--columns': stampColumns(),
                         '--placeholder-container-size': placeholderContainerSize() + 'px'
                     }">
                    @for (cell of cells(); track cell) {
                        <div class="content-details-body-stamps-cell">
                            <div class="content-details-body-stamps-cell-container">
                                <div class="content-details-body-stamps-cell-container-placeholder"
                                     woa-responsive [fontScale]=".05">
                                    @if (cell < usageCount()) {
                                        <woa-icon class="content-details-body-stamps-cell-container-placeholder-stamp"
                                                  [name]="stampIcon()"
                                                  [woa-css-var]="{'--rotation': getStampRotation(cell)}"
                                        ></woa-icon>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
        <div class="content-details-footer" woa-responsive [fontScale]=".05">
            <span class="content-details-footer-text" id="ticket-description-{{index()}}"
                  [innerHTML]="'woa.message.ticket.text' | translate: {
                      usageDescription: ticket().description || '{' + '{woa.message.ticket.defaultUsageDescription}' + '}',
                      used: span('content-details-description-text-used', 'ticket-used-' + index, usageCount()),
                      limit: span('content-details-description-text-limit', 'ticket-limit-' + index, ticket().usageLimit),
                      remaining: span('content-details-description-text-remaining', 'ticket-remaining-' + index, ticket().usageLimit - usageCount())
                 }">
            </span>
        </div>
    </div>
</div>
